import { FieldProps } from 'formik'
import React from 'react'
import { Form } from 'react-bulma-components'
import FormField, { FormFieldProps } from './form-field'
import { get } from 'lodash'

export interface CheckboxFieldProps extends FormFieldProps, FieldProps {
  /** Label displayed next to the checkbox (inline, not above). */
  label?: React.ReactNode
}

/**
 * Formik checkbox field with inline label (Bulma checkbox pattern).
 */
const CheckboxField: React.FunctionComponent<CheckboxFieldProps> = props => {
  const { field, form, label, help } = props

  return (
    <FormField help={help} error={get(form.errors, field.name) as string}>
      <Form.Control>
        <Form.Checkbox
          name={field.name}
          checked={!!field.value}
          onChange={() => form.setFieldValue(field.name, !field.value)}
          onBlur={field.onBlur}
          data-testid={`checkbox-${field.name}`}
        >
          {label}
        </Form.Checkbox>
      </Form.Control>
    </FormField>
  )
}

export default CheckboxField
